import { EditSquareIcon } from '@/components/icons'

export function IntentsEmptyState() {
  return (
    <div data-testid="intents-empty-state" className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16">
      <EditSquareIcon className="h-12 w-12 text-muted-foreground" />
      <h3 className="mt-4 text-lg font-semibold">No intents yet</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Click +New Intent to add an item.
      </p>
    </div>
  )
}
